// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CookiePrivacyPolicyState from "@store/Framework/Store/Greif/Components/CookiePrivacyPolicy/CookiePrivacyPolicyState";
import { Draft } from "immer";

const initialState: CookiePrivacyPolicyState = {
    isOpen: false,
};

const actions = {
    "Greif/Components/CookiePrivacyPolicy/SetIsOpen": (
        draft: Draft<CookiePrivacyPolicyState>,
        action: { isOpen: boolean },
    ) => {
        draft.isOpen = action.isOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsCookiePrivacyPolicyActions = Parameters<typeof reducer>[1];
export default reducer;
